import React from "react";
import MovieCard from "./MovieCard";

const MovieList = ({ title, movies }) => {
  if (!movies) return <h1>Siraj</h1>;
  return (
    <div className="p-6">
      <h1 className="text-3xl py-6 text-white">{title}</h1>
      <div className="flex overflow-x-scroll scrollbar-hide">
        <div className="flex">
          {movies.map((movie) => (
            <MovieCard posterPath={movie.poster_path} data={movie} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default MovieList;
